var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 37.466 37.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "9NTLff.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.097,2.967l.004,22.099c-.129,1.715-1.329,2.908-3.036,3.036H3.036c-1.715-.129-2.908-1.329-3.036-3.036V3.036C.129,1.322,1.329.128,3.036,0l22.223.024c1.572.169,2.704,1.37,2.837,2.943ZM19.462,13.973v3.732S7.941,6.286,7.941,6.286l-.139-.063c-.107.019-1.501,1.435-1.551,1.532-.029.056-.049.09,0,.145l11.455,11.561h-3.731s0,2.341,0,2.341h6.329c.315,0,.893-.335,1.099-.584.176-.212.401-.727.401-.989v-6.256s-2.341,0-2.341,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.244,18.734v3.146s3.073,0,3.073,0v12.439h-12.438v-3.073s-3.146,0-3.146,0v4.939c0,.529.873,1.292,1.427,1.281l15.807.003c.842-.076,1.417-.662,1.5-1.5l-.003-15.808c.011-.553-.752-1.427-1.281-1.427h-4.939Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.ac16589e.svg";
export { ForwardRef as ReactComponent };